/**
 * The `environment` tag for every Sentry.init call (client, server, edge).
 *
 * NODE_ENV is "production" on every Vercel build, so it cannot tell production, preview and
 * the custom "staging" environment apart. Vercel's target env can:
 * - VERCEL_TARGET_ENV is "production", "preview", "development" or the custom environment's
 *   name (e.g. "staging"). VERCEL_ENV says "preview" for custom environments, so it is only the
 *   fallback.
 * - The browser bundle reads the NEXT_PUBLIC_ copies Vercel adds for Next.js
 *   (NEXT_PUBLIC_VERCEL_TARGET_ENV / NEXT_PUBLIC_VERCEL_ENV), inlined at build time.
 * Docs: https://vercel.com/docs/environment-variables/system-environment-variables
 *       https://vercel.com/docs/environment-variables/framework-environment-variables
 *
 * Callers pass the variables as literal `process.env.X` reads, because Next.js only inlines
 * NEXT_PUBLIC_ values into the client bundle when they are referenced literally.
 */
export type SentryEnvironmentSource = {
  targetEnv?: string;
  vercelEnv?: string;
  nodeEnv?: string;
};

export function resolveSentryEnvironment({ targetEnv, vercelEnv, nodeEnv }: SentryEnvironmentSource) {
  for (const value of [targetEnv, vercelEnv, nodeEnv]) {
    const trimmed = value?.trim();
    if (trimmed) return trimmed;
  }
  return undefined;
}
